<template>
  <v-dialog persistent v-model="approveModal" width="700">
    <v-card>
      <v-card-title class="headline blue darken-3 white--text" default-title
      >Approve Visa Request
      </v-card-title
      >
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <form-error-display-handler :errors="errors"/>
            <v-flex xs12>
              <v-form
                  ref="approveForm"
                  v-model="valid"
                  lazy-validation
                  class="px-2"
              >
                <v-alert type="info" outlined>
                  Visa Issued for {{ visaRequest.duration }} days.
                  <span v-if="!isEtaApplication">
                    Visa will be valid from {{ start_date }} to
                    {{ visaRequest && visaRequest.expiry_date ? visaRequest.expiry_date : enddate }}
                  </span>
                </v-alert>

                <new-date-picker
                    v-if="!isEtaApplication"
                    class="pl-1 pr-1 mb-4"
                    label="Visa Start Date *"
                    v-model="start_date"
                    :min-year="2010"
                    :for-passport="true"
                />
                <v-text-field
                    v-if="isGratis === 0 && !visaRequest.visa_print_system_active"
                    class="mt-6"
                    label="Visa Sticker Number *"
                    outlined
                    v-model="visa_sticker_number"
                    @keydown="
                    notAllowToInput(
                      $event,
                      visa_sticker_number.toString().length
                    )
                  "
                    :rules="[
                    rules.required,
                    rules.number,
                    rules.maxStickerNumberLen,
                  ]"
                />
                <v-textarea
                    label="Remarks"
                    outlined
                    v-model="approveForm.remarks"
                />

                <multiple-file-upload
                    label="Upload documents (if any)"
                    v-model="approveForm.files"
                />
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="red lighten-1" class="white--text" @click="closeModal"
        >Close
        </v-btn>
        <v-btn
            color="blue darken-3"
            :loading="loading"
            class="white--text"
            @click="approve"
        >Approve
        </v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import FileInput from "../FileInput";
import moment from "moment";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import {validationMixin} from "../../mixins/validationMixin";
import MultipleFileUpload from "../MultipleFileUpload";
import NewDatePicker from "../NewDatePicker";
import {SET_PRINT_CONTENT, SET_PRINT_TYPE} from "@/store/mutation-type";

export default {
  data: () => ({
    valid: true,
    approveForm: {},
    errors: [],
    loading: false,
    start_date: "",
    visa_number: null,
    visa_sticker_number: null,
    main_person_visa_number: null,
  }),
  components: {
    NewDatePicker,
    FormErrorDisplayHandler,
    FileInput,
    MultipleFileUpload,
  },
  mounted() {
    if (this.visaNumber !== undefined) this.visa_number = this.visaNumber;

    if (this.visaStartDate) {
      this.start_date = this.visaStartDate;
    }
  },
  props: ["status", "visaNumber", "visaStartDate", "isGratis", "submissionNo"],
  mixins: [validationMixin],
  watch: {
    visaStartDate(value) {
      this.start_date = this.visaStartDate;
    },
  },
  computed: {
    ...mapGetters("VisaRequestSingle", ["visaRequest"]),
    approveModal: {
      get() {
        return this.$store.state.VisaRequestSingle.approveModal;
      },
      set(value) {
        this.$store.commit("VisaRequestSingle/setApproveModal", value);
      },
    },
    canEditVisaNumber() {
      console.log(this.visa_number);
      if (this.visa_number) {
        const start_number = this.visa_number.substr(0, 1);
        return start_number === "G";
      }
    },
    isEtaApplication() {
      return this.submissionNo.substr(0, 1) === 'Z';
    },
    enddate() {
      let start_date = this.start_date;

      return moment(start_date, "YYYY-MM-DD")
          .add(this.visaRequest.duration, "days")
          .subtract(1, "days")
          .format("Y-MM-DD");
    },
  },
  methods: {
    ...mapActions("VisaRequestSingle", ["approveRequest"]),
    approve() {
      this.approveForm.start_date = this.start_date;
      if (this.$refs.approveForm.validate()) {
        let formData = new FormData();
        formData.append("start_date", this.approveForm.start_date);
        formData.append("visa_sticker_number", this.visa_sticker_number);
        formData.append("expiry_date", this.visaRequest && this.visaRequest.expiry_date ? this.visaRequest.expiry_date : this.enddate);
        formData.append("isGratis", this.isGratis);
        if (this.showInsertDependentVisaNumber)
          formData.append("main_visa_number", this.main_person_visa_number);

        if (this.approveForm.remarks !== undefined) {
          formData.append("remarks", this.approveForm.remarks);
        } else {
          formData.append("remarks", "");
        }
        let files = this.approveForm.files;
        if (files !== undefined) {
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }
        this.loading = true;
        this.approveRequest(formData)
            .then(() => {
              this.form = false;
              this.approveForm = [];
              this.errors = null;
              this.approveModal = false;
              this.loading = false;
              this.$store.commit(
                  "Notification/showSuccess",
                  "Visa requested approved successfully"
              );
              this.$store.commit("VisaRequestSingle/setVisaNumberModal", true);
              // if (this.visaRequest.visa_print_system_active) {
              //   this.$store.commit("VisaRequestSingle/setVisaNumberPrintModal", true);
              // } else {
              //   this.$store.commit("VisaRequestSingle/setVisaNumberModal", true);
              // }
              this.$refs.approveForm.reset();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.$store.commit(
                  "Notification/showError",
                  error.response.data.message
              );
            });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    },
    closeModal() {
      this.approveForm = {};

      this.approveModal = false;
    },
    notAllowToInput(e, length) {
      console.log(length);
      if (
          length === 6 &&
          e.keyCode !== 46 && // keycode for delete
          e.keyCode !== 8
      ) {
        e.preventDefault();
      }
    },
  },
};
</script>
